// extracted by mini-css-extract-plugin
module.exports = {"container":"TOPPagination_container__1qwyD","btnprevnext":"TOPPagination_btnprevnext__28UUL","btnpages":"TOPPagination_btnpages__8Zjpz"};